"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestHandleFetch = exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _UA = _interopRequireDefault(require("../UA"));

var _webViewConnect = _interopRequireDefault(require("../webViewConnect"));

var _safeHelper = _interopRequireDefault(require("../safeHelper"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var JOIN_TOKEN_KEY = 'tokenCondition';
var notAllowValue = [undefined, null, ''];

var _joinWebViewQuery = function _joinWebViewQuery() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isFormData = arguments.length > 1 ? arguments[1] : undefined;
  var filterVal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : notAllowValue;
  var defaultCondition = _UA["default"].env.shanSongApp || _UA["default"].env.wxMiniProgram || _UA["default"].env.shanSong_redBookMini || _UA["default"].env.douYinMini;
  var condition = obj[JOIN_TOKEN_KEY] !== undefined ? obj[JOIN_TOKEN_KEY] : defaultCondition;
  var res;

  if (condition) {
    var token = _webViewConnect["default"].getValue(_webViewConnect["default"].KEYS.token);

    var tokenType = _webViewConnect["default"].getValue(_webViewConnect["default"].KEYS.tokenType);

    var apiVersion = _webViewConnect["default"].getValue(_webViewConnect["default"].KEYS.apiVersion);

    res = _objectSpread({}, obj);

    if (!filterVal.includes(apiVersion)) {
      res.apiVersion = apiVersion;
    }

    if (!filterVal.includes(token)) {
      res.token = token;
    }

    if (!filterVal.includes(tokenType)) {
      res.tokenType = tokenType;
    }
  } else {
    res = obj;
  }

  delete res[JOIN_TOKEN_KEY];

  if (isFormData) {
    var formData = new FormData();

    if (res instanceof Object) {
      Object.keys(res).map(function (key) {
        if (!filterVal.includes(res[key])) {
          formData.append(key, res[key]);
        }
      });
    }

    res = Object.keys(res).length > 0 ? formData : null;
  }

  return res;
};

var METHOD = {
  GET: 'GET',
  POST: 'POST',
  DELETE: 'DELETE',
  PUT: 'PUT'
};

var isJson = function isJson(res) {
  try {
    return (0, _typeof2["default"])(res.data) === 'object';
  } catch (error) {
    return false;
  }
};

var requestHandle = function () {
  var _ref = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee() {
    var configs,
        params,
        method,
        isFormData,
        pubParamsJoinInQueryString,
        url,
        withCredentials,
        headers,
        reqCfg,
        curCityId,
        sendData,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            configs = _args.length > 0 && _args[0] !== undefined ? _args[0] : {
              withCredentials: false,
              url: '',
              headers: {},
              openBdHeader: false,
              openPostQuery: false
            };
            params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            method = _args.length > 2 && _args[2] !== undefined ? _args[2] : METHOD.GET;
            isFormData = _args.length > 3 && _args[3] !== undefined ? _args[3] : false;
            pubParamsJoinInQueryString = _args.length > 4 && _args[4] !== undefined ? _args[4] : false;
            url = configs instanceof Object ? configs.url : configs;
            withCredentials = configs instanceof Object ? !!configs.withCredentials : false;
            headers = (configs instanceof Object ? configs.headers : {}) || {};

            if (params instanceof Object) {
              _context.next = 10;
              break;
            }

            throw new TypeError("axios error: api [".concat(url, "] params must be instanceof object"));

          case 10:
            if (method === METHOD.GET) {
              isFormData = false;
              pubParamsJoinInQueryString = false;
            }

            reqCfg = {
              method: method,
              url: url,
              headers: headers,
              withCredentials: withCredentials
            };
            _context.prev = 12;

            if (!(configs instanceof Object && configs.openBdHeader && window.bd)) {
              _context.next = 17;
              break;
            }

            _context.next = 16;
            return bd.getHeaderParams(true);

          case 16:
            reqCfg.headers.beidou = _context.sent;

          case 17:
            _context.next = 22;
            break;

          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](12);

            if (/sensors-verify/.test(navigator.userAgent)) {
              console.warn('ios 初始化,header补偿策略。');
              reqCfg.headers.beidou = _context.t0;
            } else {
              console.error('北斗header错误～');
              console.error(_context.t0);
            }

          case 22:
            try {
              if (!reqCfg.headers.gateWayCityId) {
                if (_UA["default"].env.shanSong_sellerApp) {
                  if (_webViewConnect["default"].getValue(_webViewConnect["default"].KEYS.cityId)) {
                    reqCfg.headers.gateWayCityId = _webViewConnect["default"].getValue(_webViewConnect["default"].KEYS.cityId);
                  }
                } else if (_UA["default"].env.userPC) {
                  curCityId = localStorage.getItem('CityId') || '';

                  if (curCityId) {
                    reqCfg.headers.gateWayCityId = curCityId;
                  }
                } else {
                  if (_webViewConnect["default"].getValue(_webViewConnect["default"].KEYS.cityCode)) {
                    reqCfg.headers.gateWayCityId = _webViewConnect["default"].getValue(_webViewConnect["default"].KEYS.cityCode);
                  }
                }
              }
            } catch (error) {
              console.error(error);
            }

            sendData = _joinWebViewQuery(params, isFormData);

            if (method === METHOD.GET) {
              reqCfg.params = sendData;
            } else {
              if (configs.openPostQuery) {
                reqCfg.params = sendData;
              }

              reqCfg.data = sendData;
              reqCfg.credentials = 'include';

              if (pubParamsJoinInQueryString) {
                reqCfg.url = _queryStr(reqCfg.url, {
                  token: sendData.token,
                  tokenType: sendData.tokenType,
                  apiVersion: sendData.apiVersion
                });
              }
            }

            return _context.abrupt("return", new Promise(function (resolve, reject) {
              if (_safeHelper["default"].isAndroidApp()) {
                console.log('requestHelper - 处理前 reqCfg:', reqCfg);

                var _RequestAdapter$useAx = _safeHelper["default"].useAxios(reqCfg.url, reqCfg),
                    newUrl = _RequestAdapter$useAx.url,
                    newConfig = _RequestAdapter$useAx.config;

                console.log('requestHelper - 返回的 newUrl:', newUrl);
                console.log('requestHelper - 返回的 newConfig:', newConfig);
                reqCfg.url = newUrl;
                Object.assign(reqCfg, newConfig);
                console.log('requestHelper - 处理后 reqCfg:', reqCfg);
              }

              (0, _axios["default"])(reqCfg).then(function (res) {
                try {
                  if (_safeHelper["default"].isAndroidApp()) {
                    console.log(888882, res.headers.encryptswitch, !isJson(res));
                    var encryptSwitch = res.headers.encryptswitch || res.headers.encryptSwitch;
                    var shouldDecrypt = encryptSwitch === 'true' || encryptSwitch === true || !isJson(res);
                    console.log(8888831, res, shouldDecrypt);

                    if (shouldDecrypt) {
                      res = _safeHelper["default"].useResponse(reqCfg.url, res);
                    }
                  }
                } catch (error) {}

                var errorCode = res.data.status || '';
                var errorMsg = res.data.err || '';

                if (errorCode !== 200) {
                  console.log("".concat(errorCode, ":").concat(errorMsg) || '');
                }

                resolve(res.data || '发生网络错误');
              })["catch"](function (error) {
                console.log(error);
                reject(error || '服务异常，请稍后再试');
              });
            }));

          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[12, 19]]);
  }));

  return function requestHandle() {
    return _ref.apply(this, arguments);
  };
}();

var PUBLIC_HEADER = {
  credentials: 'include',
  headers: {}
};

var _queryStr = function _queryStr(url, query) {
  var filterVal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : notAllowValue;
  query = _joinWebViewQuery(query);
  var queryStr = Object.keys(query).reduce(function (ary, key) {
    if (!filterVal.includes(query[key])) {
      ary.push(encodeURIComponent(key) + '=' + encodeURIComponent(query[key]));
    }

    return ary;
  }, []).join('&');
  var res = url += queryStr ? "?".concat(queryStr) : '';
  return res;
};

var requestHandleFetch = function requestHandleFetch(Fetch) {
  var configs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var method = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : METHOD.GET;
  var filterVal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : notAllowValue;
  var url = configs instanceof Object ? configs.url : configs;
  var headers = configs instanceof Object ? configs.headers || {} : {};
  var isFormData = configs.isFormData !== false;

  if (!(params instanceof Object)) {
    throw new TypeError("fetch error: api [".concat(url, "] params must be instanceof object"));
  }

  url = method === METHOD.GET ? _queryStr(url, params, filterVal) : url;
  var content = method === METHOD.GET ? {} : _objectSpread({
    method: method,
    body: _joinWebViewQuery(params, isFormData, filterVal)
  }, PUBLIC_HEADER);

  if (params._customerService) {
    content.headers = headers;
  }

  return Fetch(url, content);
};

exports.requestHandleFetch = requestHandleFetch;

var joinFormData = function joinFormData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var formData = new FormData();

  if (data instanceof Object) {
    Object.keys(data).map(function (key) {
      formData.append(key, data[key]);
    });
  }

  data = Object.keys(data).length > 0 ? formData : null;
  return data;
};

var _default = {
  joinFormData: joinFormData,
  requestHandleFetch: requestHandleFetch,
  JOIN_TOKEN_KEY: JOIN_TOKEN_KEY,
  METHOD: METHOD,
  requestHandle: requestHandle
};
exports["default"] = _default;